import React from 'react';
import styled from "styled-components";
import { colors } from "../utils/helpers";

const Titulo = styled.h1`
			color: ${colors.black};
			font-size: 1.4em;
			padding-top: 1em;
			font-weight: 700;
			padding-bottom: 0.5em;
		`;

const Bolo = (props) => {
	return <Titulo>{props.texto}</Titulo>
}

export default Bolo;


// WEBPACK FOOTER //
// ./src/components/Bolo.js